import React, {
  useCallback,
  useMemo,
  useRef,
  useEffect,
  useState,
} from "react";
import * as Global from "../styles/Global";
import {
  ContentSection,
  FlexColumn,
  TextOnlyButton,
  FlexRow,
  LargeButton,
  LargeButtonSecondary,
  ButtonText,
  SlideUpModal,
  ModalOverlay,
  FormInputField,
  Text,
} from "../styles/Global";
import { connect, useSelector } from "react-redux";
import { auth } from "../services/firebaseConfig";
//AG-Grid
import { AgGridReact } from "@ag-grid-community/react";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { RowGroupingModule } from "@ag-grid-enterprise/row-grouping";
import { MenuModule } from "@ag-grid-enterprise/menu";
import { SetFilterModule } from "@ag-grid-enterprise/set-filter";
import { BiRefresh } from "react-icons/bi";
import { IoIosArrowDropupCircle } from "react-icons/io";
import { IoMdRemoveCircleOutline } from "react-icons/io";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { BsFillPlusCircleFill, BsFilterRight } from "react-icons/bs";
import useLocalStorage from "../CustomHooks/useLocalStorage";
import "../App.scss";
//AG-Grid
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-alpine.css";
import TournamentsFilterOptions from "./TournamentsFilterOptions";
import { setLoadingStatus } from "../features/refreshScreen/refreshScreenSlice";

const mapDispatch = { setLoadingStatus };

const GridTableClientSecure = ({
  data,
  dataCall,
  apiURL,
  dataCallBody,
  error,
  setModalData,
  ShowModalType,
  shouldShowModal,
  columnDefs,
  rowClassRules,
  defaultColDef,
  showSearchBar,
  paginationPageSize,
  refreshGrid,
  showFilter,
  noBorder,
  noHeader,
  isFullWidthRow,
  fullWidthCellRenderer,
  tableValue,
  setValue,
  apiFullURL,
  tableType,
  rowHeight,
  setAllowTabClicks,
  setLoadingStatus,
}) => {
  const modules = useMemo(
    () => [
      ClientSideRowModelModule,
      MenuModule,
      SetFilterModule,
      RowGroupingModule,
    ],
    []
  );
  const [upcomingFilter, setUpcomingFilter] = useLocalStorage(
    "upcoming",
    "All"
  );
  const [pastFilter, setPastFilter] = useLocalStorage("past", "All");
  const refreshOrganizerScreen = useSelector(
    (state) => state.refresh.refreshOrganizerScreen
  );

  const refreshSeasonsScreen = useSelector(
    (state) => state.refresh.refreshSeasonsScreen
  );
  const sport = new URL(window.location.href).pathname.split("/")[2];
  const account = useSelector((state) => state.organizer.accountid);
  const [openFilter, setOpenFilter] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [dateRange, setDateRange] = useState(
    tableType === "current" ? upcomingFilter : pastFilter
  );
  const [seasonOptions, setSeasonOptions] = useState("All");
  const [format, setFormat] = useState("All");
  const [generation, setGeneration] = useState("All");
  const [currentDataCallBody, setCurrentDataCallBody] = useState(null);
  const gridRef = useRef();
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [isGridRefreshing, setIsGridRefreshing] = useState(false);
  const pathEnv = new URL(window.location.href).host.split(".")[0];

  //console.log("lastUsedParams: ", lastUsedParams);
  console.log("tableValue: ", tableValue);
  console.log("tableType: ", tableType);

  window.refreshGrid = async function () {
    console.log("window.refreshGrid GridTableClientInsecure running...");
    // setTimeout(() => {
    try {
      // setValue(0);
      getRowData({
        sport: sport,
        type: tableType,
        accountid: account,
        range: upcomingFilter,
        seasonOptions: seasonOptions,
        timezone: tz,
        environment:
          pathEnv === "app" ? "production" : pathEnv === "beta" ? "beta" : "",
      });
    } catch (error) {
      console.log("refreshGrid error: ", error);
    }
    // }, 1000);
  };

  useEffect(() => {
    console.log("value updated useEffect: ", tableType);
    setDateRange(tableType === "current" ? upcomingFilter : pastFilter);
  }, [tableType]);

  const getRowData = useCallback((request, delay) => {
    console.log("request: ", request);
    console.log("apiFullURL: ", apiFullURL);
    console.log("settingLoadingStatus true");
    setLoadingStatus({ isOrgTournamentListLoading: true });
    return fetch(
      `${
        apiFullURL
          ? apiFullURL
          : `${process.env.REACT_APP_API_BASE_URL}/apiv2/${apiURL}`
      }`,
      // ` http://localhost:5001/scoreholio/us-central1/apisecurev2/${apiURL}`,
      {
        method: "post",
        body: JSON.stringify(request),
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
      }
    )
      .then((httpResponse) => {
        if (!httpResponse.ok) {
          throw new Error(`HTTP error! status: ${httpResponse.status}`);
        }
        return httpResponse.json();
      })
      .then((response) => {
        console.log("response: ", response);
        if (gridRef.current && gridRef.current.api) {
          console.log("gridRef.current.api exists. Setting row Data");
          // Check if response has rows property
          if (response && Array.isArray(response.rows)) {
            gridRef.current.api.setRowData(response.rows);
          } else {
            console.warn(
              "Response does not contain valid rows array:",
              response
            );
            gridRef.current.api.setRowData([]);
          }
          setTimeout(() => {
            setLoadingStatus({ isOrgTournamentListLoading: false });
            if (typeof setAllowTabClicks === "function") {
              setAllowTabClicks(true);
            }
          }, 1000);
        }
      })
      .catch((error) => {
        console.error("dataSource error: ", error);

        // Clear any existing data and show error state
        if (gridRef.current && gridRef.current.api) {
          gridRef.current.api.setRowData([]);
          gridRef.current.api.hideOverlay();
        }

        // Reset loading state
        setTimeout(() => {
          setLoadingStatus({ isOrgTournamentListLoading: false });
          if (typeof setAllowTabClicks === "function") {
            setAllowTabClicks(true);
          }
        }, 1000);

        // Show user-friendly error message
        console.error(
          "Failed to load data. Please check your connection and try again."
        );
      });
  }, []);

  const onGridReady = (params) => {
    const newParams = { ...params.request, ...dataCallBody };
    console.log("onGridReady params.request: ", params.request);
    getRowData(newParams);
  };

  useEffect(() => {
    console.log("dataCallBody: ", dataCallBody);
    console.log("currentDataCallBody: ", currentDataCallBody);
    if (currentDataCallBody && currentDataCallBody.type !== dataCallBody.type) {
      console.log("dataCallBody useEffect running");
      console.log("dataCallBody: ", dataCallBody);
      console.log("currentDataCallBody: ", currentDataCallBody);
      if (gridRef.current && gridRef.current.api) {
        gridRef.current.api.setRowData([]);
        gridRef.current.api.showLoadingOverlay();
      }
      if (refreshOrganizerScreen > 0 && tableType === "past") {
        getRowData({ ...dataCallBody, type: "past" });
      } else {
        getRowData(dataCallBody);
      }
    }
    setCurrentDataCallBody(dataCallBody);
  }, [dataCallBody]);

  useEffect(() => {
    if (refreshOrganizerScreen > 0) {
      console.log("refreshOrganizerScreen getRowData");
      getRowData(dataCallBody);
    }
  }, [refreshOrganizerScreen]);

  useEffect(() => {
    if (refreshSeasonsScreen > 0) {
      console.log("refreshSeasonsScreen getRowData");
      getRowData(dataCallBody);
    }
  }, [refreshSeasonsScreen]);

  const onRowClicked = useCallback((event) => {
    const selectedRow = event.data;
    //do stuff with selectedRow
    if (shouldShowModal) {
      setModalData({ ...selectedRow, isGridRefreshing });
      ShowModalType();
      event.node.setSelected(false);
    }
  }, []);

  const defaultColDefFallback = useMemo(() => {
    return {
      resizable: true,
      wrapText: true,
      autoHeight: true,
      suppressMenu: true,
    };
  }, []);

  const onFirstDataRendered = useCallback((params) => {
    if (gridRef.current && gridRef.current.api) {
      gridRef.current.api.sizeColumnsToFit();
    }
  }, []);

  const customFilter = useCallback((e, type, colId, tableValue) => {
    if (!gridRef.current || !gridRef.current.api) return;

    console.log("e: ", e);
    console.log("type: ", type);
    console.log("colId: ", colId);

    // Handle search type first (doesn't need a filter instance)
    if (type === "search") {
      gridRef.current.api.setQuickFilter(e);
      setSearchValue(e);
      return;
    }

    // Handle clearing all filters
    if (!e && type !== "search") {
      const nameFilter = gridRef.current.api.getFilterInstance("name");
      const teamCreateFilter =
        gridRef.current.api.getFilterInstance("teamCreate");
      const formatFilter = gridRef.current.api.getFilterInstance("format");

      if (nameFilter) nameFilter.setMiniFilter(null);
      if (teamCreateFilter) teamCreateFilter.setMiniFilter(null);
      if (formatFilter) formatFilter.setMiniFilter(null);

      setFormat("All");
      setGeneration("All");
      setDateRange("All");
      gridRef.current.api.onFilterChanged();
      return;
    }

    // Get filter instance for column-specific filtering
    const filterInstance = gridRef.current.api.getFilterInstance(colId);

    // Check if filterInstance exists
    if (!filterInstance) {
      console.warn(`Filter instance not found for column: ${colId}`);
      return;
    }

    // Set the mini Filter with the correct value
    if (type === "select" && e === "All") {
      filterInstance.setMiniFilter(null);
    } else {
      filterInstance.setMiniFilter(e);
    }

    //Do this to make sure the model is set
    filterInstance.applyModel();
    //Do this to refresh the columns
    gridRef.current.api.onFilterChanged();
  }, []);

  //console.log("rowData: ", data);
  const getRowHeight = useCallback(
    function (params) {
      console.log("getRowHeight running? ", rowHeight);
      console.log("getRowHeight tableType? ", tableType);
      // return 100px height for full width rows
      return rowHeight ? rowHeight : tableType === "template" ? 75 : 100;
    },
    [tableType]
  );

  //console.log("GridTableClientSecure refreshGrid: ", refreshGrid);

  return (
    <div style={{ height: "100%", width: "100%" }} className="ag-theme-alpine">
      {showSearchBar && (
        <FlexRow
          justify="space-between"
          align="center"
          style={{ flex: 0, padding: "5px 10px 0 0" }}
        >
          <div
            className="inputField"
            style={{
              marginLeft: 10,
              flex: 1,
              position: "relative",
            }}
          >
            <FormInputField
              id="outlined-basic"
              label="Search"
              variant="outlined"
              value={searchValue}
              fullWidth
              margin="dense"
              onChange={(e) => customFilter(e.target.value, "search", null)}
              style={{ padding: 0 }}
              size="small"
            />
            {searchValue !== "" && (
              <AiOutlineCloseCircle
                size={20}
                color={Global.blueLight}
                style={{
                  position: "absolute",
                  zIndex: 100,
                  right: 10,
                  top: "50%",
                  transform: `translateY(-50%)`,
                  backgroundColor: "#fff",
                  borderRadius: 20,
                  cursor: "pointer",
                }}
                onClick={() => customFilter("", "search", null)}
              />
            )}
          </div>
          <BiRefresh
            size={30}
            color={Global.blueLight}
            style={{
              padding: 2,
              marginTop: 5,
              marginLeft: 10,
              backgroundColor: "transparent",
              borderRadius: 20,
              cursor: "pointer",
            }}
            onClick={() => getRowData(dataCallBody)}
          />
          {showFilter && (
            <BsFilterRight
              size={30}
              color={
                openFilter ||
                format !== "All" ||
                generation !== "All" ||
                dateRange !== "All"
                  ? Global.red
                  : Global.blueLight
              }
              style={{
                padding: 2,
                marginTop: 5,
                marginLeft: 10,
                backgroundColor: "transparent",
                borderRadius: 20,
                cursor: "pointer",
              }}
              onClick={() => setOpenFilter(!openFilter)}
            />
          )}
        </FlexRow>
      )}
      {(format !== "All" || generation !== "All" || dateRange !== "All") && (
        <FlexRow
          style={{
            marginTop: 5,
            // width: "100%",
            padding: "0 15px",
            flexWrap: "wrap",
          }}
          // align="flex-start"
          // justify="space-between"
        >
          {/* <FlexRow align="center" style={{ flexWrap: "wrap" }}> */}
          {format !== "All" && (
            <div
              className="filterPill"
              style={{
                cursor: "pointer",
              }}
              onClick={() => setFormat("All")}
            >
              <Text size="1em" color="red">
                {format}
              </Text>
              <IoMdRemoveCircleOutline
                size={17}
                color={Global.red}
                style={{
                  padding: 2,
                  marginLeft: 2,
                  backgroundColor: "transparent",
                }}
              />
            </div>
          )}
          {generation !== "All" && (
            <div
              className="filterPill"
              style={{
                cursor: "pointer",
              }}
              onClick={() => setGeneration("All")}
            >
              <Text size="1em" color="red">
                {generation}
              </Text>
              <IoMdRemoveCircleOutline
                size={17}
                color={Global.red}
                style={{
                  padding: 2,
                  marginLeft: 2,
                  backgroundColor: "transparent",
                }}
              />
            </div>
          )}
          {dateRange !== "All" && (
            <div
              className="filterPill"
              style={{
                cursor: "pointer",
              }}
              onClick={() => {
                setDateRange("All");
                if (tableType === "current") {
                  setUpcomingFilter("All");
                } else {
                  setPastFilter("All");
                }
              }}
            >
              <Text size="1em" color="red">
                {dateRange}
              </Text>
              <IoMdRemoveCircleOutline
                size={17}
                color={Global.red}
                style={{
                  padding: 2,
                  marginLeft: 2,
                  backgroundColor: "transparent",
                }}
              />
            </div>
          )}
          <div
            style={{
              cursor: "pointer",
            }}
            onClick={() => {
              console.log("tableType customFilter: ", tableType);
              if (tableType === "current") {
                console.log("tableType customFilter: ", tableType);
                setUpcomingFilter("All");
                getRowData({
                  sport: sport,
                  type: "current",
                  accountid: account,
                  range: "All",
                  timezone: tz,
                  seasonOptions: seasonOptions,
                  environment:
                    pathEnv === "app"
                      ? "production"
                      : pathEnv === "beta"
                      ? "beta"
                      : "",
                });
              } else {
                setPastFilter("All");
                getRowData({
                  sport: sport,
                  type: "past",
                  accountid: account,
                  range: "All",
                  timezone: tz,
                  seasonOptions: seasonOptions,
                  environment:
                    pathEnv === "app"
                      ? "production"
                      : pathEnv === "beta"
                      ? "beta"
                      : "",
                });
              }
              customFilter(null);
            }}
            className="filterPill"
          >
            <Text size="1em" color="red">
              Clear All
            </Text>
            <IoMdRemoveCircleOutline
              size={17}
              color={Global.red}
              style={{
                padding: 2,
                marginLeft: 2,
                backgroundColor: "transparent",
                // borderRadius: 20,
              }}
            />
          </div>
          {/* </FlexRow> */}
        </FlexRow>
      )}
      <FlexColumn
        className={`filterSection ${openFilter && "showFilterSection"}`}
      >
        {tableType === "seasons" ? (
          <Text>Seasons filters</Text>
        ) : (
          <TournamentsFilterOptions
            openFilter={openFilter}
            format={format}
            setFormat={setFormat}
            customFilter={customFilter}
            generation={generation}
            setGeneration={setGeneration}
            tableType={tableType}
            dateRange={dateRange}
            setDateRange={setDateRange}
            seasonOptions={seasonOptions}
            setSeasonOptions={setSeasonOptions}
            setUpcomingFilter={setUpcomingFilter}
            getRowData={getRowData}
            dataCallBody={dataCallBody}
            setPastFilter={setPastFilter}
            setOpenFilter={setOpenFilter}
          />
        )}
      </FlexColumn>
      <AgGridReact
        className={`findTournamentGrid ${noBorder && "noBorder"}`}
        // serverSideStoreType="partial"
        // rowModelType="serverSide"
        // gridOptions={gridOptions}
        pagination={true}
        paginationPageSize={paginationPageSize ? paginationPageSize : "10"}
        paginationPageSizeSelector={[10, 25, 50, 100]}
        cacheBlockSize="50"
        suppressMovableColumns="true"
        suppressContextMenu="true"
        modules={modules}
        // rowHeight={rowHeight}
        ref={gridRef}
        columnDefs={columnDefs}
        defaultColDef={defaultColDef ? defaultColDef : defaultColDefFallback}
        rowClassRules={rowClassRules}
        rowSelection="single"
        onRowClicked={onRowClicked}
        onFirstDataRendered={onFirstDataRendered}
        onGridReady={onGridReady}
        domLayout="autoHeight"
        headerHeight={noHeader ? 0 : 30}
        isFullWidthRow={isFullWidthRow}
        fullWidthCellRenderer={fullWidthCellRenderer}
        getRowHeight={getRowHeight}
        overlayNoRowsTemplate={`<Text style="margin-top: -45px; font-size: 1.2em">No ${tableType === 'seasons' ? 'Seasons' : tableType === 'events' ? 'Events' : tableType === 'template' ? 'Templates' : 'Tournaments'}. Create One!</Text>`}
        overlayLoadingTemplate="<span><img height='50' src='https://app.scoreholio.com/img/loading400.gif'/></span>"
        // autoHeight={true}
      />
    </div>
  );
};

export default connect(null, mapDispatch)(GridTableClientSecure);
